import { debounce } from "@/utils/utils";
// 定义一个名为debounce的指令
export default {
  // 绑定的值为el，和binding
  // binding的值为指令绑定的值,binding中有哪些值，可以去vue官网中查看自定义指令
  bind(el, binding) {
    const time = binding.arg || 1000;
    el.addEventListener("click", debounce(binding.value, time));
  },
};
